import React from 'react';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { sessionLogGridColumns, addSessionLogColumns } from '../constants';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { Button, Icons } from '../../../components/base/BootstrapComponents';

export default function SessionLogGrid(props) {
  const {
    data = [],
    loadData = () => {},
    onClickByRow = () => {},
    setShowCloseModal = () => {},
    meta = {},
  } = props;

  const isCancelableSession = item => ['in_progress', 'ACTIVE'].includes(item?.status);

  const moreFormatter = (_, item) => {
    if (!isCancelableSession(item)) {
      return <Icons customIcon icon="dot" className="more-vert" />;
    }

    return (
      <TooltipWithPortal
        content={<Icons customIcon icon="dot" className="more-vert" />}
        classNamePortal="more-actions"
        tooltipContent={(
          <div className="more-wrapper">
            <Button variant="link" className="w-100 more-button delete" onClick={() => setShowCloseModal(item)}>
              Отменить сессию
            </Button>
          </div>
        )}
        classNameWrapper="more-tooltip-wrapper"
        className="more-tooltip"
      />
    );
  };

  return (
    <div className="slp-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="slp-grid" onClickByRow={onClickByRow} data={data} columns={sessionLogGridColumns} additionalColumns={addSessionLogColumns} name="slp-list-v2" settingsFormatter={moreFormatter} respectHidden />
        </div>
      </div>
      <Pagination meta={meta} list={data} handleChangeMeta={loadData} />
    </div>
  );
}
